import { makeAutoObservable } from "mobx";

import { userStorageName } from '@/constants/user';
import { getDataFromStorage } from '@/utils/app';

import type { User } from '@/types/User';

class StoreUser {
    user: User | null = null;

    constructor() {
        makeAutoObservable(this);

        this.initUser();
    }

    initUser() {
        const storageData = getDataFromStorage(userStorageName)

        const storageDataFormatted = JSON.parse(storageData);
        this.user = storageDataFormatted || null;
    }

    setUser(user: User | null) {
        console.log('setUSer', user)
        this.user = user;
    }

    logout() {
        this.user = null
    }

    get userRole():string {
        const roleName = this?.user?.role ?? ''

        return roleName
    }

    get isCanRemove():boolean {
        let roleName = this?.user?.role ?? ''

        if(roleName === 'admin' || roleName === 'superadmin') {
            return true
        }

        return false
    }

    get isSuperAdmin():boolean {
        return this?.user?.role === 'superadmin'
    }
}

export const storeUser = new StoreUser();